import createApiServices from "./createApiServices"
import {getRefreshToken} from "../AuthServices"
import {extendUrlFulfillment} from "../../views/helpers/extenent-url"

const prefixURL = `${extendUrlFulfillment.url}/api/auth` || 'https://fulfillment-staging.merchize.com/api/auth'
const api = createApiServices({baseUrl: prefixURL})

export const refreshToken = (data) => {
    return api.makeAuthRequest({
        url: '/auth/refresh-token',
        method: 'POST',
        data: {
            refreshToken: getRefreshToken()
        },
    })
}

export const getUserList = (query) => {
    return api.makeAuthRequest({
        url: `users`,
        method: 'GET',
        params: query,
    })
}